import React, { useState } from "react";
import close from "../../assets/icons/close.svg";
import "../../assets/css/Modal.css";
import { CreatePIN } from "./CreatePin";
import Session from "../../Utils/Sessions";
import { Postdata } from "../../API/GlobalApi";
import Notifier from "../../Utils/notify";
import useAutoFocus from "../../Utils/autoFocus";

export const ImposeFeePlanPreview = ({
    isOpen,
    onClose,
    planMode,
    selectedCourse,
    selectedSemester,
    students,
    selectedStudent,
    feeRows,
    onContinue,
    selectedSessionName
}) => {

    const planModeLabel = planMode === "course" ? "Course-wise" : "Student-wise";
    const [openPinGenerateModal, setOpenPinGenerateModal] = useState(false);
    const [pin, setPin] = useState("");
    const ref = useAutoFocus(isOpen)
    if (!isOpen) return null;



    // 🔹 Total per student (sum of all fee heads)
    const perStudentTotal = feeRows.reduce(
        (sum, row) => sum + Number(row.amount || 0),
        0
    );




    // 🔹 Multiply by number of selected students
    // const totalAmount = (selectedStudent?.length || 0) * perStudentTotal;

    const totalAmount =
        selectedStudent?.length > 0
            ? selectedStudent.length * perStudentTotal
            : perStudentTotal;


    const handleVerifyPinAndContinue = async () => {
        if (pin.length !== 4) return;

        try {
            const payload = { pin };
            const res = await Postdata("core/verify-user-pin/", payload);

            if (!res?.error) {
                // Notifier.success("PIN verification successfully");
                if (typeof onContinue === "function") onContinue();
                setPin("");
            } else {
                Notifier.error(res?.data?.message || "Invalid PIN");
            }
        } catch (err) {
            console.error("Error verifying PIN:", err);
            Notifier.error("Something went wrong while verifying PIN");
        }
    };
    // 🔹 Print Function
    const handlePrint = () => {
        // 🔹 Close modal first
        if (typeof onClose === "function") onClose();

        // 🔹 Get content wrapper (optional, not strictly needed for dynamic table)
        const printWrapper = document.getElementById("print-wrapper");

        // 🔹 Build table HTML dynamically
        const tableHtml = planMode === "course"
            ? `<table border="1" cellspacing="0" cellpadding="6" style="width:100%; border-collapse: collapse; font-size:14px;">
            <thead>
                <tr>
                <th style="text-align:left;">Fee Head</th>
                <th style="text-align:right; width:120px;">Amount</th> <!-- set fixed width -->
                </tr>
            </thead>
            <tbody>
                ${feeRows.map(row => `
                <tr>
                    <td>${row.fee_type_head}</td>
                    <td style="text-align:right; width:120px;">₹ ${Number(row.amount || 0).toFixed(2)}</td>
                </tr>
                `).join("")}
            </tbody>
            <tfoot>
        <tr style="font-weight:bold;">
            <td style="text-align:left;">Total</td>
            <td style="text-align:right;">
                ₹ ${feeRows.reduce((sum, row) => sum + Number(row.amount || 0), 0).toFixed(2)}
            </td>
        </tr>
    </tfoot>
            </table>
            `
            : `<table border="1" cellspacing="0" cellpadding="6" style="width:100%; border-collapse: collapse; font-size:14px;">
            <thead>
                <tr>
                    <th>Student Name</th>
                    <th>Reg No</th>
                    <th>Fee Head</th>
                    <th style="text-align:right;  width:120px;">Amount</th>
                </tr>
            </thead>
            <tbody>
                ${students
                .filter(stu => selectedStudent.includes(stu.id))
                .flatMap(stu =>
                    feeRows.map(row => `
                            <tr>
                                <td>${stu.name}</td>
                                <td>${stu.rollNumber}</td>
                                <td>${row.fee_type_head}</td>
                                <td style="text-align:right;  width:120px;">₹ ${Number(row.amount || 0).toFixed(2)}</td>
                            </tr>
                        `)
                ).join("")}
            </tbody>
              <tfoot>
            <tr style="font-weight:bold;">
                <td colspan="3" style="text-align:left;">Total</td>
                <td style="text-align:right;">
                    ₹ ${students
                .filter(stu => selectedStudent.includes(stu.id))
                .flatMap(() => feeRows.map(row => Number(row.amount || 0)))
                .reduce((sum, amt) => sum + amt, 0)
                .toFixed(2)}
                </td>
            </tr>
        </tfoot>
        </table>`;

        const newWindow = window.open("width=800,height=1100");
        newWindow.document.write(`
        <html>
            <head>
                <title>Impose Fee Plan Preview</title>
                <style>
                    body { 
                        font-family: "Courier New", Courier, monospace; 
                        padding: 40px 0; 
                        color: #222F3E; 
                        background: #fff;
                    }
                    .print-container {
                        width: 600px;
                        margin: 0 auto;
                    }
                    h2, h3, p { margin: 4px 0; text-align: left; }
                    hr { border: 0; border-top: 1px dashed #222F3E; margin: 10px 0; }
                    table { width: 100%; border-collapse: collapse; font-size: 14px; margin-top: 10px; }
                    table th, table td { border: 1px solid #222F3E; padding: 6px; }
                    table th { text-align: left; }
                    .right { text-align: right; }
                    .notice-page { page-break-after: always; }
                </style>
            </head>
            <body>
                <div class="print-container notice-page">
                    <div class="center">
                        <h2>BITE College</h2>
                        <p>Banaras Institute of Teachers Education</p>
                        <hr />
                        <h3>Impose Fee Plan Preview - ${planMode === "course" ? "Course-wise" : "Student-wise"}</h3>
                        <hr />
                    </div>
                   
                    <p><strong>Course:</strong> ${selectedCourse?.label || "-"}</p>
                    ${selectedSemester ? `<p><strong>Semester:</strong> ${selectedSemester.label}</p>` : ""}
                    <p><strong>Total Students:</strong> ${selectedStudent.length}</p>
                    <p><strong>Total Imposed Fee:</strong> ₹ ${totalAmount.toFixed(2)}</p>
                    <hr />

                    ${tableHtml}

                    <div style="margin-top:80px; display:flex; justify-content:flex-end; width:100%;">
                    
                    <div>Director</div>
                     </div>
                    <hr />
                    <div class="center">
                        <p>Generated on: ${new Date().toLocaleString()}</p>
                    </div>
                </div>
            </body>
        </html>
    `);

        newWindow.document.close();
        newWindow.focus();
        newWindow.print();
        newWindow.close();
    };




    return (
        <>
            <div className="modal-overlay">
                <div
                    className="modal-content recevingPaymentBody"
                    id="print-wrapper"
                    style={{
                        position: "relative",
                        width: "70%",
                        display: "flex",
                        flexDirection: "column",
                        minHeight: "30vh",
                        maxHeight: "85vh",
                        height: "auto",
                        padding: "20px",
                    }}
                >
                    {/* Header */}
                    <div
                        className="modal-header-content "

                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                        }}
                    >
                        <h2 className="text-primary">
                            Impose Fee : {planModeLabel} Preview
                        </h2>
                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                            <button className="add-btn" onClick={handlePrint}>
                                Print Preview
                            </button>
                            <button className="close-btn" onClick={() => {
                                onClose()
                                setPin('')
                            }}>
                                <img src={close} alt="close" />
                            </button>
                        </div>
                    </div>

                    {/* Course/Semester Details + Total */}

                    <div
                        style={{
                            marginBottom: "15px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",

                        }}
                    >
                        <div
                            style={{

                                display: "flex",
                                flexDirection: "column",
                                // alignItems: "center",
                                gap: '10px'

                            }}>
                            {/* {selectedSessionName && (
                                <p>
                                    <strong>Admission Academic Year:</strong> {selectedSessionName}
                                </p>
                            )} */}
                            <p>
                                <strong>Course:</strong> {selectedCourse?.label}
                            </p>
                            {selectedSemester && (
                                <p>
                                    <strong>Semester:</strong> {selectedSemester.label}
                                </p>
                            )}
                            <p>
                                <strong>Total Students:</strong> {selectedStudent.length}
                            </p>
                        </div>

                        <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                            Total Imposed Fee: ₹ {totalAmount.toFixed(2)}
                        </div>
                    </div>

                    {/* Scrollable Table Section */}
                    <div style={{ flex: 1, overflowY: "auto" }}>
                        {planMode === "course" ? (
                            <table className="table table-bordered mt-3 feeplantables">
                                <thead
                                    style={{
                                        position: "sticky",
                                        top: 0,
                                        background: "#fff",
                                        zIndex: 2,
                                    }}
                                >
                                    <tr>
                                        <th>Fee Head</th>
                                        <th style={{ textAlign: "right" }}>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {feeRows.map((row, i) => (
                                        <tr key={i}>
                                            <td>{row.fee_type_head}</td>
                                            <td style={{ textAlign: "right" }}>
                                                ₹ {Number(row.amount || 0).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr style={{ fontWeight: "bold" }}>
                                        <td style={{ textAlign: "left" }}>Total</td>
                                        <td colSpan={3} style={{ textAlign: "right" }}>
                                            ₹ {feeRows.reduce((sum, row) => sum + Number(row.amount || 0), 0).toFixed(2)}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        ) : (
                            <table className="table table-bordered mt-3 feeplantables">
                                <thead
                                    style={{
                                        position: "sticky",
                                        top: 0,
                                        background: "#fff",
                                        zIndex: 2,
                                    }}
                                >
                                    <tr>
                                        <th>Student Name</th>
                                        <th>Reg No</th>
                                        <th>Fee Head</th>
                                        <th style={{ textAlign: "right" }}>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {students
                                        .filter((stu) => selectedStudent.includes(stu.id))
                                        .flatMap((stu) =>
                                            feeRows.map((row, i) => (
                                                <tr key={`${stu.id}-${i}`}>
                                                    <td>{stu.name}</td>
                                                    <td>{stu.rollNumber}</td>
                                                    <td>{row.fee_type_head}</td>
                                                    <td style={{ textAlign: "right" }}>
                                                        ₹ {Number(row.amount || 0).toFixed(2)}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                </tbody>
                                <tfoot style={{
                                    position: "sticky",
                                    bottom: 0,
                                    background: "#fff",
                                    zIndex: 2,
                                }}>
                                    <tr style={{ fontWeight: "bold" }}>
                                        <td colSpan={3} style={{ textAlign: "left" }}>Total</td>
                                        <td style={{ textAlign: "right" }}>
                                            ₹ {students
                                                .filter((stu) => selectedStudent.includes(stu.id))
                                                .flatMap(() => feeRows.map((row) => Number(row.amount || 0)))
                                                .reduce((sum, amt) => sum + amt, 0)
                                                .toFixed(2)}
                                        </td>
                                    </tr>
                                </tfoot>

                            </table>
                        )}
                    </div>

                    {/* Footer */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "end",
                            marginTop: "20px",
                        }}
                    >
                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                            <input
                                type="password"
                                className="form-control"
                                maxLength={4}
                                placeholder="Enter 4-digit PIN"
                                ref={ref}
                                value={pin}
                                onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
                                style={{
                                    width: "150px",
                                    padding: "8px 10px",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                    outline: "none",
                                    boxSizing: "border-box",
                                }}

                            />

                            {/* {!Session.get("security_pin") && (
                                <button
                                    className="add-btn"
                                    onClick={() => setOpenPinGenerateModal(true)}
                                >
                                    Create PIN
                                </button>
                            )} */}

                            <button
                                className="add-btn"
                                onClick={handleVerifyPinAndContinue}
                                disabled={pin.length !== 4}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    cursor: pin.length !== 4 ? "not-allowed" : "pointer",
                                    backgroundColor:
                                        pin.length !== 4 ? "#d3d3d3" : "#7F56DA",
                                }}
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <CreatePIN
                isOpen={openPinGenerateModal}
                onClose={() => setOpenPinGenerateModal(false)}
                pin={pin}
                setPin={setPin}
            />
        </>
    );
};
